// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"f68e46ac","299":"230a8238","307":"fdc9b61e","362":"515eca00","492":"02ad99b4","634":"550fc9ae","814":"5f14d023","889":"a84e530d","941":"d3f7c1dc","965":"555aab8c"}[chunkId] + ".chunk.js";
};